import { styled } from "@monolith-forensics/monolith-ui";

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 20px;

  border: 1px solid ${({ theme }) => theme.palette.divider};
  border-radius: 8px;
`;
